"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = select_r_c_b;
function select_r_c_b(data, r, c) {
  return data[r][c];
}